(function () {
    'use strict';

    function waitForDOM(callback) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', callback);
        } else {
            callback();
        }
    }

    const domCache = {};
    const priceLabels = () => document.getElementById('product-variant-price')?.dataset || {};
    const oldPriceKey = () => priceLabels().originalPriceLabel || 'Original price';
    const discountKey = () => priceLabels().discountLabel || 'Discount';

    function getCachedElement(selector, context = document) {
        if (!domCache[selector]) {
            domCache[selector] = context.querySelector(selector);
        }
        return domCache[selector];
    }

    function getCachedElements(selector, context = document) {
        const cacheKey = `all_${selector}`;
        if (!domCache[cacheKey]) {
            domCache[cacheKey] = context.querySelectorAll(selector);
        }
        return domCache[cacheKey];
    }

    function clearDOMCache() {
        Object.keys(domCache).forEach(key => delete domCache[key]);
    }

    function initCartProperties() {
        const productForm = getCachedElement('#product-form') ||
            getCachedElement('form[action*="cart/add"]');

        if (!productForm) {
            return;
        }

        createHiddenPropertyInputs(productForm);
        setupVariantMonitoring(productForm);
    }

    function createHiddenPropertyInputs(productForm) {
        const oldInputs = productForm.querySelectorAll('#cart-property-old-price, #cart-property-discount');
        oldInputs.forEach(input => input.remove());

        const oldPriceInput = document.createElement('input');
        oldPriceInput.type = 'hidden';
        oldPriceInput.name = `properties[${oldPriceKey()}]`;
        oldPriceInput.id = 'cart-property-old-price';
        productForm.appendChild(oldPriceInput);

        const discountInput = document.createElement('input');
        discountInput.type = 'hidden';
        discountInput.name = `properties[${discountKey()}]`;
        discountInput.id = 'cart-property-discount';
        productForm.appendChild(discountInput);
    }

    function setupVariantMonitoring(productForm) {
        const variantContainer = getCachedElement('.product-variants') || productForm;

        variantContainer.addEventListener('click', handleVariantClick, true);

        const variantSelect = getCachedElement('#product_select');
        if (variantSelect) {
            variantSelect.addEventListener('change', handleSelectChange);
        }

        const initialVariant = getCachedElement('[data-pm-variant-id].available');
        if (initialVariant) {
            updateCartProperties(initialVariant);
        }

        setupAddToCartInterception(productForm);
    }

    function handleVariantClick(event) {
        const variantOption = event.target.closest('[data-pm-variant-id]');
        if (variantOption && variantOption.classList.contains('available')) {
            updateCartProperties(variantOption);
        }
    }

    function handleSelectChange(event) {
        const selectedOption = event.target.options[event.target.selectedIndex];
        if (selectedOption && selectedOption.dataset.pmVariantId) {
            const variantElement = getCachedElement(`[data-pm-variant-id="${selectedOption.dataset.pmVariantId}"]`);
            if (variantElement) {
                updateCartProperties(variantElement);
            }
        }
    }

    function setupAddToCartInterception(productForm) {
        function syncSelectedSize() {
            const currentVariant = productForm.querySelector('[data-pm-variant-id].active') ||
                productForm.querySelector('[data-pm-variant-id].available');
            if (currentVariant) updateCartProperties(currentVariant);
            interceptCartAddRequest();
        }
        productForm.addEventListener('submit', syncSelectedSize, true);
        productForm.addEventListener('click', function (event) {
            if (event.target.closest('button[add-to-cart-button]')) syncSelectedSize();
        }, true);
    }

    function updateCartProperties(variantElement) {
        const variantId = variantElement.getAttribute('data-pm-variant-id');
        const comparePrice = variantElement.getAttribute('data-pm-variant-compare-price');
        const currentPrice = variantElement.getAttribute('data-pm-variant-price');

        const variantInput = getCachedElement('#productID');
        if (variantInput && variantId) {
            variantInput.value = variantId;
        }

        // Keep the customer's requested size separate from the physical variant.
        const productForm = variantElement.closest('#product-form');
        const cutInput = productForm && productForm.querySelector('.fake-property');
        if (cutInput) {
            const requestedSize = variantElement.textContent.trim();
            const needsCutting = variantElement.getAttribute('data-show-fake') === 'true';
            cutInput.value = needsCutting ? requestedSize : '';
            const message = productForm.querySelector('.fake-message');
            if (message) message.style.display = needsCutting ? 'block' : 'none';
        }

        clearCartProperties();

        if (comparePrice && currentPrice && comparePrice.trim() && currentPrice.trim()) {
            const comparePriceNum = parseFloat(comparePrice.replace(/[^\d,.-]/g, '').replace(',', '.'));
            const currentPriceNum = parseFloat(currentPrice.replace(/[^\d,.-]/g, '').replace(',', '.'));

            if (!isNaN(comparePriceNum) && !isNaN(currentPriceNum) && comparePriceNum > currentPriceNum) {
                const discount = Math.floor(((comparePriceNum - currentPriceNum) / comparePriceNum) * 100);
                setCartProperties(comparePrice, `${discount}% ${priceLabels().saleText || ''}`.trim());
            }
        }
    }

    function setCartProperties(oldPrice, discountText) {
        const oldPriceInput = getCachedElement('#cart-property-old-price');
        const discountInput = getCachedElement('#cart-property-discount');

        if (oldPriceInput && discountInput) {
            const strikethroughPrice = oldPrice.split('').map(char => char + '\u0336').join('');
            oldPriceInput.value = strikethroughPrice;
            discountInput.value = discountText;
        }
    }

    function clearCartProperties() {
        const oldPriceInput = getCachedElement('#cart-property-old-price');
        const discountInput = getCachedElement('#cart-property-discount');

        if (oldPriceInput) oldPriceInput.value = '';
        if (discountInput) discountInput.value = '';
    }

    function interceptCartAddRequest() {
        if (window.cartPropertiesInterceptActive) {
            return;
        }

        window.cartPropertiesInterceptActive = true;
        const originalFetch = window.fetch;

        window.fetch = function (url, options) {
            if (url.includes('cart/add.js') && options && options.body) {
                try {
                    const requestData = JSON.parse(options.body);

                    if (requestData.items && requestData.items.length > 0) {
                        const oldPriceInput = getCachedElement('#cart-property-old-price');
                        const discountInput = getCachedElement('#cart-property-discount');

                        if (oldPriceInput && oldPriceInput.value &&
                            discountInput && discountInput.value) {

                            if (!requestData.items[0].properties) {
                                requestData.items[0].properties = {};
                            }

                            requestData.items[0].properties[oldPriceKey()] = oldPriceInput.value;
                            requestData.items[0].properties[discountKey()] = discountInput.value;
                        }
                    }

                    const productForm = document.querySelector('#product-form');
                    const cutInput = productForm && productForm.querySelector('.fake-property');
                    const selected = productForm && productForm.querySelector('[variant-option="available"].active');
                    if (cutInput && selected && requestData.items) {
                        const physicalId = selected.getAttribute('data-pm-variant-id');
                        requestData.items.forEach(item => {
                            if (String(item.id) !== physicalId) return;
                            item.properties = item.properties || {};
                            item.properties['Bestelde maat'] = selected.textContent.trim() + ' cm';
                            if (selected.getAttribute('data-show-fake') === 'true') {
                                item.properties.cut = 'Inkorten tot ' + selected.textContent.trim() + ' cm';
                            } else {
                                delete item.properties.cut;
                            }
                        });
                    }

                    options.body = JSON.stringify(requestData);
                } catch (error) {
                    console.error('Error intercepting cart/add request:', error);
                }
            }

            return originalFetch.call(this, url, options);
        };

        setTimeout(() => {
            window.fetch = originalFetch;
            window.cartPropertiesInterceptActive = false;
        }, 2000);
    }

    waitForDOM(function () {
        initCartProperties();
    });

    if (window.MutationObserver) {
        const observer = new MutationObserver(function (mutations) {
            let shouldReinit = false;

            mutations.forEach(mutation => {
                if (mutation.type === 'childList') {
                    const addedNodes = Array.from(mutation.addedNodes);
                    if (addedNodes.some(node =>
                        node.nodeType === 1 &&
                        (node.matches('[data-pm-variant-id]') ||
                            node.querySelector('[data-pm-variant-id]')))) {
                        shouldReinit = true;
                    }
                }
            });

            if (shouldReinit) {
                clearDOMCache();
                initCartProperties();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

})();

